export default class Accordion {
	constructor(el) {
		this.el = el;
		this.items = null;
		this.init();
	}

	init() {
		this.items = this.el.querySelectorAll("[js-accordion-item]");
		this.items.forEach((item) => {
			const toggleBtn = item.querySelector("[js-accordion-btn]");
			const submenuID = toggleBtn.getAttribute("aria-controls");
			const submenu = item.querySelector("#" + submenuID);
			if (!!toggleBtn && !!submenu) {
				toggleBtn.addEventListener("click", (e) => this.toggleSubmenu(toggleBtn, submenu));
			}
		});
	}

	toggleSubmenu(btn, submenu) {
		const isOpen = btn.getAttribute("aria-expanded") === "true";

		isOpen ? this.closeSubmenu(btn, submenu) : this.openSubmenu(btn, submenu);
	}

	openSubmenu(btn, submenu) {
		this.disableBtn(btn);
		this.items.forEach((item) => {
			const toggleBtn = item.querySelector("[js-accordion-btn]");
			const subId = toggleBtn.getAttribute("aria-controls");
			const sub = item.querySelector("#" + subId);
			this.closeSubmenu(toggleBtn, sub);
		});
		btn.setAttribute("aria-expanded", true);
		submenu.classList.add("--expanded");
	}

	closeSubmenu(btn, submenu) {
		this.disableBtn(btn);
		btn.setAttribute("aria-expanded", false);
		submenu.classList.remove("--expanded");
	}

	disableBtn(btn) {
		btn.disabled = true;
		setTimeout(() => {
			btn.disabled = false;
		}, 500);
	}
}
